import request from "@/utils/request";

const api = {
  GetSsoHost: 'sso-host',
  GetLoginUserInfo: 'login-user',
  GetDefaultPasswordRequired: 'getDefaultPasswordRequired',
  GetCurrentWorkbench: "/current-workbench",
  GetCurrentNavigation: "/current-navigation",
  GetNavigationDetail: "/navigation/detail",
  AppList: "/workbench/current-app",
  AddCommonApp: "/workbench/add-common-app",
  DeleteCommonApp: "/workbench/delete-common-app",
  AddHideApp: "/workbench/add-hide-app",
  DeleteHideApp: "/workbench/delete-hide-app",
  GetEmpContacts: "/contacts/emp"

};

/**
 * 是否强制修改密码
 * @returns {*}
 */
export function getDefaultPasswordRequired() {
  return request({
    url: api.GetDefaultPasswordRequired,
    method: 'get'
  })
}

export function getSsoHost(parameter) {
  return request({
    url: api.GetSsoHost,
    method: "get",
    params: parameter,
  });
}

export function getLoginUserDetail(parameter) {
  return request({
    url: api.GetLoginUserInfo,
    method: "get",
    params: parameter,
  });
}

export function getCurrentWorkbench(parameter) {
  return request({
    url: api.GetCurrentWorkbench,
    method: "get",
    params: parameter,
  });
}

export function getCurrentNavigation(parameter) {
  return request({
    url: api.GetCurrentNavigation,
    method: "get",
    params: parameter,
  });
}

export function getNavigationDetail(parameter) {
  return request({
    url: api.GetNavigationDetail,
    method: "get",
    params: parameter,
  });
}

export function getAppList(parameter) {
  return request({
    url: api.AppList,
    method: "get",
    params: parameter,
  });
}

export function addCommonApp(parameter) {
  return request({
    url: api.AddCommonApp,
    method: "post",
    params: parameter,
  });
}

export function deleteCommonApp(parameter) {
  return request({
    url: api.DeleteCommonApp,
    method: "post",
    params: parameter,
  });
}

export function addHideApp(parameter) {
  return request({
    url: api.AddHideApp,
    method: "post",
    params: parameter,
  });
}

export function deleteHideApp(parameter) {
  return request({
    url: api.DeleteHideApp,
    method: "post",
    params: parameter,
  });
}

export function getEmpContacts(parameter) {
  return request({
    url: api.GetEmpContacts,
    method: "get",
    params: parameter,
  });
}
